import { styled } from '@spazious/dollhouse-theme';

import { BaseCSSProperties, BaseCSSPropertiesList, BaseExtendProps } from './types.js';

const camelToKebabCase = (str: string): string => {
  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

const parseCssProps = (props: BaseCSSProperties) => {
  return BaseCSSPropertiesList.map((propName) =>
    props[propName] !== undefined ? `${camelToKebabCase(propName)}: ${props[propName]};` : ''
  ).join('\n');
};

export const createBase = <T extends keyof React.JSX.IntrinsicElements>(tag: T) => {
  return styled(tag).withConfig({
    shouldForwardProp: (prop) => !BaseCSSPropertiesList.includes(prop as any),
    displayName: 'Base',
  })<BaseExtendProps<React.JSX.IntrinsicElements[T]>>`
    ${parseCssProps}
  `;
};
